import { createContext, type PropsWithChildren, useContext, useState } from 'react'
import { useMenuOutboundLayoutContext } from 'widgets/Menu/ui/MenuOutbound'
import { SurveysPageStore } from 'pages/surveys/store/surveysPageStore'

export const SurveysPageContext = createContext<SurveysPageStore | null>(null)

export const useSurveysPageContext = () => {
  const context = useContext(SurveysPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SurveysPageContext')

  return context
}

export const SurveysPageProvider = ({ children }: PropsWithChildren) => {
  const menuLayoutStore = useMenuOutboundLayoutContext()
  const [store] = useState(() => new SurveysPageStore(menuLayoutStore.pageLayoutStore))

  return <SurveysPageContext.Provider value={store}>{children}</SurveysPageContext.Provider>
}
